import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react";
import { toast } from "sonner";
import { AuthShell } from "@/components/AuthShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, formatApiErrorDetail } from "@/lib/api";

export default function ResetPassword() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [showPw, setShowPw] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      toast.error("Le password non coincidono.");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", {
        token,
        password,
        confirm_password: confirm,
      });
      toast.success("Password aggiornata. Ora puoi accedere.");
      navigate("/login");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <AuthShell testid="reset-invalid-card" title="Link non valido" subtitle="Richiedi un nuovo link di reset." />
    );
  }

  return (
    <AuthShell testid="reset-card" title="Nuova password">
      <form onSubmit={submit} className="flex flex-col gap-4">
        <div className="flex flex-col gap-1.5">
          <Label htmlFor="password">Nuova password</Label>
          <div className="relative">
            <Input
              id="password"
              data-testid="reset-password-input"
              type={showPw ? "text" : "password"}
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="pr-10"
            />
            <button
              type="button"
              data-testid="reset-password-toggle"
              onClick={() => setShowPw((v) => !v)}
              aria-label={showPw ? "Nascondi password" : "Mostra password"}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-[#9a8f83] hover:text-[#4a433c]"
            >
              {showPw ? <EyeOff size={18} /> : <Eye size={18} />}
            </button>
          </div>
        </div>
        <div className="flex flex-col gap-1.5">
          <Label htmlFor="confirm">Conferma password</Label>
          <div className="relative">
            <Input
              id="confirm"
              data-testid="reset-confirm-input"
              type={showConfirm ? "text" : "password"}
              required
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              className="pr-10"
            />
            <button
              type="button"
              data-testid="reset-confirm-toggle"
              onClick={() => setShowConfirm((v) => !v)}
              aria-label={showConfirm ? "Nascondi password" : "Mostra password"}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-[#9a8f83] hover:text-[#4a433c]"
            >
              {showConfirm ? <EyeOff size={18} /> : <Eye size={18} />}
            </button>
          </div>
        </div>
        <Button
          type="submit"
          data-testid="reset-submit-btn"
          disabled={loading}
          className="w-full bg-[#e8836b] hover:bg-[#d76f57] text-white rounded-full py-6 text-sm font-semibold disabled:opacity-50"
        >
          {loading ? "Aggiornamento…" : "REIMPOSTA PASSWORD"}
        </Button>
      </form>
    </AuthShell>
  );
}
